class FieldResumeDto {
    FieldReferenceId: number;
    OriginalName: string;
    OverriddenName: string;

    constructor(
        fieldReferenceId: number,
        originalName: string,
        overriddenName: string
    ) {
        this.FieldReferenceId = fieldReferenceId;
        this.OriginalName = originalName;
        this.OverriddenName = overriddenName;
    }

    get Label(): string {
        if (this.OverriddenName === this.OriginalName) {
            return this.OriginalName;
    }
        else {
            return this.OverriddenName + ' (' + this.OriginalName + ')';
    }
}
}

export default FieldResumeDto;
